(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  var coll = document.getElementsByClassName("footer-collapsible");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  var cont = document.getElementsByClassName("footer-content");
  var i;

  for (i = 0; i < cont.length; i++) {
    cont[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  $(document).ready(function() {
    /******************************
        BOTTOM SCROLL TOP BUTTON
     ******************************/

    // declare variable
    var scrollTop = $(".scrollTop");

    $(window).scroll(function() {
      // declare variable
      var topPos = $(this).scrollTop();

      // if user scrolls down - show scroll to top button
      if (topPos > 100) {
        $(scrollTop).css("opacity", "1");

      } else {
        $(scrollTop).css("opacity", "0");
      }

    }); // scroll END

    //Click event to scroll to top
    $(scrollTop).click(function() {
      $('html, body').animate({
        scrollTop: 0
      }, 1400);
      return false;

    }); // click() scroll top EMD


  }); // ready() END


    // Start IE11 compatibility //
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      // CSSVar Polyfill
      document.write('<script src="https://cdn.jsdelivr.net/gh/nuxodin/ie11CustomProperties@4.1.0/ie11CustomProperties.min.js"></script>');

      document.documentElement.className = document.documentElement.className.replace('js', 'no-js');

      document.addEventListener('DOMContentLoaded', function () {
        var elsToLazyload = document.querySelectorAll('.lazyload');
        for (var i = 0; i < elsToLazyload.length; i++) {
          var elToLazyLoad = elsToLazyload[i];
          elToLazyLoad.removeAttribute('src');
          var src = elToLazyLoad.getAttribute('data-src').replace('_{width}x.', '_600x.');
          elToLazyLoad.setAttribute('src', src);
          elToLazyLoad.classList.remove('lazyload');
          elToLazyLoad.classList.add('lazyloaded');
        }
      });
    }
  // End IE11 compatibility //

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const scheda1WM = document.getElementById("man-shoes-size-guide");
  const scheda2WM = document.getElementById("man-shoes-how-to");
  const mostraScheda1ButtonWM = document.getElementById("show-man-shoes-size-guide");
  const mostraScheda2ButtonWM = document.getElementById("show-shoes-how-to");

  mostraScheda1ButtonWM.onclick = function () {
      scheda1WM.classList.add("active");
      scheda2WM.classList.remove("active");
      mostraScheda1ButtonWM.classList.add("active-scd");
      mostraScheda2ButtonWM.classList.remove("active-scd");
  };

  mostraScheda2ButtonWM.onclick = function () {
      scheda2WM.classList.add("active");
      scheda1WM.classList.remove("active");
      mostraScheda2ButtonWM.classList.add("active-scd");
      mostraScheda1ButtonWM.classList.remove("active-scd");
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function() {
    let popupShown = false;

    function checkScroll() {
      if (popupShown) return;

      // Altezza totale del documento meno l’altezza viewport
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      // Pixels scorsi
      const scrolled = window.scrollY || window.pageYOffset;
      // Percentuale di scroll
      const percent = (scrolled / scrollableHeight) * 100;

      if (percent >= 20) {
        document.querySelector("#popup").style.display = "block";
        popupShown = true;
        // Una volta mostrato, stacchiamo l'event listener per non ripetere
        window.removeEventListener("scroll", checkScroll);
      }
    }

    // Colleghiamo il listener allo scroll
    window.addEventListener("scroll", checkScroll);

    // Gestione del click su “X”
    document.querySelector("#close-popup").addEventListener("click", function() {
      document.querySelector("#popup").style.display = "none";
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prodotti-visualizzati-precedenti"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  let viewedProducts = JSON.parse(localStorage.getItem("viewed_products")) || [];
  let currentProduct = "{{ product.handle }}";
  let container = document.getElementById("last-viewed-container");

  // Filtra i prodotti che hanno tutti gli elementi necessari e che non sono il prodotto corrente
  let productsToShow = viewedProducts.filter(product => 
    product.handle &&
    product.image &&
    product.title &&
    product.price &&
    product.handle !== currentProduct
  ).slice(0, 3); // Limita a 3 prodotti

  if (productsToShow.length > 0) {
    productsToShow.forEach(product => {
      let productHTML = `
        <div style="border-radius: 0px; max-width: 100%;">
          <a href="${product.url}">
            <img src="${product.image}" alt="${product.title}" style="width: 100%;">
            <div style="margin: 5px 0;">
              <h6 style="font-size:calc(9px + .3vw) !important;">${product.title}</h6>
              <span style="font-size: 14px; color: #333;">${product.price}</span>
            </div>
          </a>
        </div>`;
      container.innerHTML += productHTML;
    });
    container.style.display = "grid";
  } else {
    // Se non ci sono prodotti da mostrare, nascondi l'intera sezione
    let section = document.querySelector(".articoli-visualizzati");
    if (section) {
      section.style.display = "none";
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-newsletter"] && !Shopify.designMode) return;
  try {
    
  // Copia del testo Coupon
  document.addEventListener('DOMContentLoaded', function() {
    const copyButton = document.getElementById('copyCoupon');
    const couponInput = document.getElementById('couponCode');
    const copyMessage = document.getElementById('copyMessage');

    if (copyButton && couponInput) {
      copyButton.addEventListener('click', function() {
        // Seleziona e copia il testo
        couponInput.select();
        couponInput.setSelectionRange(0, 99999); // Per mobile
        
        // Copia negli appunti
        navigator.clipboard.writeText(couponInput.value).then(function() {
          // Rimuovi la selezione blu
          couponInput.blur();
          window.getSelection().removeAllRanges();
          
          // Mostra il messaggio di successo
          copyMessage.style.display = 'block';
          
          // Nascondi il messaggio dopo 3 secondi
          setTimeout(function() {
            copyMessage.style.display = 'none';
          }, 3000);
        }).catch(function(err) {
          console.error('Errore nella copia:', err);
        });
      });
    }
  });


  // Tracciamento al submit del form (più affidabile)
  document.addEventListener('DOMContentLoaded', function() {
    const newsletterForm = document.querySelector('.newsletter-ss24 form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function(e) {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            content_name: 'Newsletter Signup',
            content_category: 'newsletter'
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
